"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitRecommendationMessage = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var utils_1 = require("../../../../utils");
var WithIcon_1 = require("./WithIcon");
var DirectDebitRecommendationMessage = function (_a) {
    var recommendedDD = _a.recommendedDD;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var Icon = (0, core_1.useComponents)().Icon;
    var statusList = (recommendedDD === null || recommendedDD === void 0 ? void 0 : recommendedDD.state) || [];
    if (statusList.includes('AccountInLoss')) {
        return (react_1.default.createElement(WithIcon_1.WithIcon, { styledIcon: react_1.default.createElement(Icon, { name: "elecBoltInTriangle", size: "3rem" }) },
            react_1.default.createElement(Copy, { copyKey: "switchingAwayDdMessage" })));
    }
    if (statusList.includes('BillingOnHold') ||
        statusList.includes('AmountOverSensibleUpperLimit') ||
        recommendedDD === null ||
        (recommendedDD === null || recommendedDD === void 0 ? void 0 : recommendedDD.friendlyAmount) == null) {
        return (react_1.default.createElement(WithIcon_1.WithIcon, { styledIcon: react_1.default.createElement(Icon, { name: "elecBoltInTriangle", size: "3rem" }) },
            react_1.default.createElement(Copy, { copyKey: "calculationInvalidDdMessage" })));
    }
    if (statusList.includes('RecentlyOnboarded')) {
        return (react_1.default.createElement(WithIcon_1.WithIcon, { styledIcon: react_1.default.createElement(Icon, { name: "elecBoltInTriangle", size: "3rem" }) },
            react_1.default.createElement(Copy, { copyKey: "onboardingDdMessage" })));
    }
    var formattedAmount = (0, core_1.absoluteMajor0DP)((0, core_1.majorToMinor)(recommendedDD.friendlyAmount.amount, recommendedDD.friendlyAmount.currencyUnit));
    var formattedPredictedBalance = (0, core_1.major0DP)((0, core_1.majorToMinor)(recommendedDD.predictedFinalBalance.amount, recommendedDD.predictedFinalBalance.currencyUnit));
    if (recommendedDD) {
        var finalBalanceStatus = (0, utils_1.getPredictedFinalBalanceState)(parseInt(recommendedDD.predictedFinalBalance.amount));
        var calculationEndDateCopy = (0, date_fns_1.format)(recommendedDD.calculationEndDate, 'd MMMM yyyy');
        switch (finalBalanceStatus) {
            case 'onTrack': {
                return (react_1.default.createElement(WithIcon_1.WithIcon, { styledIcon: react_1.default.createElement(Icon, { name: "star", size: "3rem" }) },
                    react_1.default.createElement(Copy, { copyKey: "directDebitOnTrack" })));
            }
            case 'smallDebt': {
                return (react_1.default.createElement(WithIcon_1.WithIcon, { styledIcon: react_1.default.createElement(Icon, { name: "bell", size: "3rem" }) },
                    react_1.default.createElement(Copy, { copyKey: "changeDirectDebitSmallDebt", values: {
                            calculationEndDate: calculationEndDateCopy,
                            predictedBalance: formattedPredictedBalance,
                            recommendedAmount: formattedAmount,
                        } })));
            }
            case 'largeDebt': {
                return (react_1.default.createElement(WithIcon_1.WithIcon, { styledIcon: react_1.default.createElement(Icon, { name: 'warningTriangle', size: "3rem" }) },
                    react_1.default.createElement(Copy, { copyKey: "changeDirectDebitLargeDebt", values: {
                            calculationEndDate: calculationEndDateCopy,
                            predictedBalance: formattedPredictedBalance,
                            recommendedAmount: formattedAmount,
                        } })));
            }
            case 'credit': {
                return (react_1.default.createElement(WithIcon_1.WithIcon, { styledIcon: react_1.default.createElement(Icon, { name: 'bell', size: "3rem" }) },
                    react_1.default.createElement(Copy, { copyKey: "changeDirectDebitCredit", values: {
                            calculationEndDate: calculationEndDateCopy,
                            predictedBalance: formattedPredictedBalance,
                            recommendedAmount: formattedAmount,
                        } })));
            }
            default: {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.DirectDebitRecommendationMessage = DirectDebitRecommendationMessage;
